import { deviceTypes } from '@styles/mediaQueries';
import { zIndexes } from '@styles/zindex/zindex';
import styled from 'styled-components';
import { getHeadingHeight } from './components/Sidebar/getHeadingHeight';
import { AssetSidebarContainer } from './components/Sidebar/Sidebar.styles';

export const Right = styled.div`
  flex: 1;
  padding: 16px;
  /* display: grid;
  grid-template-rows: 0.8fr 0.8fr 0.2fr;
  grid-gap: 16px; */
  height: 100%;
  overflow: auto;
  scroll-behavior: smooth;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  [data-device='${deviceTypes.mobile}'] & {
    overflow: visible;
  }
`;
export const RightBottom = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 16px;
  height: 34vh;
  overflow: hidden;
  margin-top: 16px;

  [data-device='${deviceTypes.mobile}'] & {
    grid-template-columns: 1fr;
    grid-auto-rows: fit-content(360px);
    height: unset;
  }
`;
export const RightMiddle = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 16px;
  height: 34vh;
  overflow: hidden;
  margin-top: 16px;

  [data-device='${deviceTypes.mobile}'] & {
    grid-template-columns: 1fr;
    grid-auto-rows: fit-content(360px);
    height: unset;
  }
`;

interface IContainer {
  'data-offsettop': number;
}

export const Container = styled.div<IContainer>`
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  display: grid;
  grid-template-columns: minmax(320px, 1fr) 3fr;
  grid-template-rows: 1fr;

  [data-device='${deviceTypes.mobile}'] & {
    grid-template-columns: minmax(250px, 1fr);
    scroll-padding: ${getHeadingHeight}px 0 0 0;

    overflow: auto;

    ${AssetSidebarContainer} {
      overflow: visible;
    }

    ${Right} {
      overflow: visible;
    }
    ${RightBottom} {
      grid-template-columns: 1fr;
    }
    ${RightMiddle} {
      grid-template-columns: 1fr;
    }
    scroll-behavior: smooth;
    /* For scrollbar to not get clipped */
    position: relative;
    z-index: ${zIndexes.indexOf('table-scrollbar')};
    grid-template-rows: minmax(min-content, 100%) 1fr;
  }
`;

export const RightTop = styled.div`
  display: flex;
  width: 100%;
  height: 50vh;
  background-color: #fff;
  border-radius: 8px;

  /*
  padding: 24px;
  border: 1px solid #e6e8f0;
  */
  [data-device='${deviceTypes.mobile}'] & {
    height: 360px;
  }
`;
